import styled from 'styled-components';
import { ResumeTabsType } from '../../../types/ResumeTypes';

interface ResumeTabMenuProps {
  resumeTabs: ResumeTabsType;
  activeTab: number;
}

const ResumeTabMenu = (props: ResumeTabMenuProps) => {
  const { resumeTabs, activeTab } = props;

  return (
    <>
      <TabMenuWrap>
        <TabUl>
          {Array.from(resumeTabs).map((tab: any, index) => {
            return (
              <>
                <TabLi onClick={tab.onMoveToElement} $isColor={activeTab === index}>
                  {tab.name}
                </TabLi>
              </>
            );
          })}
        </TabUl>
      </TabMenuWrap>
    </>
  );
};

export default ResumeTabMenu;

const TabMenuWrap = styled.div`
  width: 100%;
  margin-bottom: 4.8rem;
`;

const TabUl = styled.ul`
  width: 100%;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: var(--box-shadow);
`;

const TabLi = styled.li<{ $isColor: boolean }>`
  width: 100%;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #f8f8f8;
  /* border-bottom: 4px solid #eaedf1; */
  border-bottom: 4px solid ${(props) => (props.$isColor ? '#367c68' : '#eaedf1')};

  cursor: pointer;

  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2rem; /* 125% */
  letter-spacing: 0.0016rem;
  color: #7f8389;

  &:last-child {
    border-right: 0px;
  }
`;
